// assets
import { IconBrandChrome, IconHelp, IconUser } from '@tabler/icons';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
// constant
const icons = { IconBrandChrome, IconHelp, IconUser };

// ==============================|| USER PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const customer = {
    id: 'user-docs-roadmap3',
    type: 'group',
    children: [
        {
            id: 'customers',
            title: 'Customers',
            type: 'item',
            url: '/customers',
            icon: AccountCircleOutlinedIcon,
            breadcrumbs: false
        }
    ]
};

export default customer;
